export default "__VITE_ASSET__Bb9SY9Hr__"